export { TruncatedDirective } from './truncated.directive';
export { useTruncation } from './truncation';
